import { useState, useEffect } from 'react'
import { get, ref } from "firebase/database";
import { AreaChart } from "@tremor/react";

import ModalCustom from '../../components/utils/ModalCustom.js';

import ShowUserDetails from './ShowUserDetails.js';
import UserCreditsBalancesAdmin from './UserCreditsBalancesAdmin.js';

import { formatDateLong, formatDate, formatDate3 } from '../../utils/formatDates.js';
import { db } from '../../utils/firebaseApp.js';

export default function CreditsDashboard({
    usersInfo,
}) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [history, setHistory] = useState([]);
    const [creditBalancesByUserId, setCreditBalancesByUserId] = useState({});

    const [creditsTotal, setCreditsTotal] = useState(0);
    const [creditsToday, setCreditsToday] = useState(0);
    const [creditsMonth, setCreditsMonth] = useState(0);
    const [credistLastMonth, setCreditsLastMonth] = useState(0);

    const [creditsChart, setCreditsChart] = useState([]);

    const [lastExtractionEnabled, setLastExtractionEnabled] = useState(false);
    const [lastExtractionLoading, setLastExtractionLoading] = useState(false);
    const [lastExtractions, setLastExtractions] = useState({});

    const switchLastExtraction = async () => {
        setLastExtractionLoading(true);
        setLastExtractionEnabled(true);

        let lastExtractions = {};
        try {
            let uniqueUserIds = [...new Set(history.map(item => item.userId))];
            for (let userId of uniqueUserIds) {
                console.log('Fetching last extraction for user', userId);
                const billingRef = ref(db, `billing/${userId}`);
                const snapshot = await get(billingRef);
                let data = snapshot.val();
                if (data) {
                    let lastExtraction = null;

                    if (data.success) {
                        Object.keys(data.success).forEach((key) => {
                            if (lastExtraction === null || data.success[key].timestamp > lastExtraction.timestamp) {
                                lastExtraction = data.success[key];
                            }
                        });
                    } else {
                        Object.keys(data).forEach((key) => {
                            if (lastExtraction === null || data[key].timestamp > lastExtraction.timestamp) {
                                lastExtraction = data[key];
                            }
                        });
                    }

                    lastExtractions[userId] = lastExtraction;
                } else {
                    console.log('No data found for user', userId);
                }
            };
        } catch (error) {
            console.error('Error fetching last extractions', error);
        }

        console.log('lastExtractions', lastExtractions);

        setLastExtractionLoading(false);
        setLastExtractions(lastExtractions);
    }

    const getLastExtraction = (userId) => {
        if (lastExtractionEnabled) {
            const lastExtraction = lastExtractions[userId];
            if (lastExtraction) {
                return formatDateLong(lastExtraction.timestamp);
            } else {
                return 'no-extractions';
            }
        }
        return 'not-enabled';
    }

    const [totalPages, setTotalPages] = useState(0);
    const [totalPagesBefore, setTotalPagesBefore] = useState(0);
    const [totalPagesPartners, setTotalPagesPartners] = useState(0);
    const [totalPagesJustin, setTotalPagesJustin] = useState(0);

    const [totalPagesPrice, setTotalPagesPrice] = useState(0);
    const [totalPagesBeforePrice, setTotalPagesBeforePrice] = useState(0);
    const [totalPagesPartnersPrice, setTotalPagesPartnersPrice] = useState(0);
    const [totalPagesJustinPrice, setTotalPagesJustinPrice] = useState(0);

    const [totalUsers, setTotalUsers] = useState(0);
    const [totalTransactions, setTotalTransactions] = useState(0);

    useEffect(() => {
        const fetchCredits = async () => {
            try {
                let localTotalPages = 0;
                let localTotalPagesBefore = 0;
                let localTotalPagesPartners = 0;
                let localTotalPagesJustin = 0;

                let localTotalPagesPrice = 0;
                let localTotalPagesBeforePrice = 0;
                let localTotalPagesPartnersPrice = 0;
                let localTotalPagesJustinPrice = 0;

                let localTotalUsers = 0;
                let localUsersIds = [];

                let localTotalTransactions = 0;

                // Fetch all user billing data within the time range
                const billingRef = ref(db, 'userDetails');
                get(billingRef).then((snapshot) => {
                    if (snapshot.exists()) {
                        let data = snapshot.val();

                        let history = [];
                        const balances = {};
                        Object.keys(data).forEach((userId) => {
                            console.log('userId', userId, data[userId]);
                            const rawBalance = data[userId]?.credits?.credits;
                            balances[userId] = Number(rawBalance) || 0;
                            if (data[userId].credits) {
                                if (data[userId].credits.history) {
                                    Object.keys(data[userId].credits.history).forEach((historyKey) => {
                                        let element = data[userId].credits.history[historyKey];
                                        let elementPages = 0;

                                        if (element.pages) {
                                            elementPages = parseFloat(element.pages);
                                        } else {
                                            if (element.stripeSession.amount_total === 0) {
                                                console.log("wtf romania");
                                                elementPages = parseFloat(element.credits) / 10;
                                            } else {
                                                console.log("wtf ucraina");
                                                elementPages = parseFloat(element.stripeSession.amount_total) / 10;
                                            }
                                        }

                                        history.push({
                                            userId: userId,
                                            email: data[userId].email,
                                            credits: element.value,
                                            amount_total: element.stripeSession?.amount_total ?? 0,
                                            pages: elementPages,
                                            type: element.type ?? 'pay-as-you-go',
                                            timestamp: element.timestamp
                                        });

                                        if (userId === '4wYYo3brtUPzRhD0zkxEpO1zfPU2') {
                                            let localPage = (element.pages ? parseFloat(element.pages) : 0);
                                            localTotalPagesPartners += localPage;
                                            try {
                                                localTotalPagesPartnersPrice += (element.stripeSession?.amount_total ?? 0) / 100;
                                            } catch (error) {
                                            }
                                        } else {
                                            let localPage = (element.pages ? parseFloat(element.pages) : 0);

                                            if (localPage === 0) {
                                                let price = element.stripeSession?.amount_total ?? 0;
                                                localTotalPagesBefore += (price / 100) * 10;
                                                localTotalPagesBeforePrice += price / 100;
                                            } else {
                                                if (userId === 'cetWAxqthaMbpjvhEqUN6OY8WV03') {
                                                    localTotalPagesJustin += localPage;
                                                    try {
                                                        localTotalPagesJustinPrice += (element.stripeSession?.amount_total ?? 0) / 100;
                                                    } catch (error) {
                                                    }
                                                } else {
                                                    localTotalPages += localPage;
                                                    try {
                                                        localTotalPagesPrice += (element.stripeSession?.amount_total ?? 0) / 100;
                                                    } catch (error) {
                                                    }
                                                }
                                            }
                                        }

                                        localUsersIds.push(userId);

                                        localTotalTransactions += 1;
                                    });
                                }
                            }
                        });

                        setTotalPages(localTotalPages);
                        setTotalPagesBefore(localTotalPagesBefore);
                        setTotalPagesPartners(localTotalPagesPartners);
                        setTotalPagesJustin(localTotalPagesJustin);

                        setTotalPagesPrice(localTotalPagesPrice);
                        setTotalPagesBeforePrice(localTotalPagesBeforePrice);
                        setTotalPagesPartnersPrice(localTotalPagesPartnersPrice);
                        setTotalPagesJustinPrice(localTotalPagesJustinPrice);

                        localUsersIds = [...new Set(localUsersIds)];
                        localTotalUsers = localUsersIds.length;
                        setTotalUsers(localTotalUsers);

                        setTotalTransactions(localTotalTransactions);

                        // sort history by timestamp
                        history.sort((a, b) => {
                            const dateA = new Date(a.timestamp);
                            const dateB = new Date(b.timestamp);
                            return dateB - dateA; // sort in descending order
                        });

                        // calculate total credits
                        let today = new Date();
                        let total = 0;
                        let todayCredits = 0;
                        let monthCredits = 0;
                        let lastMonthCredits = 0;
                        history.forEach((element) => {
                            const date = new Date(element.timestamp);
                            if (date.getDate() === today.getDate() &&
                                date.getMonth() === today.getMonth() &&
                                date.getFullYear() === today.getFullYear()) {
                                todayCredits += element.amount_total;
                            }
                            if (date.getMonth() === today.getMonth() &&
                                date.getFullYear() === today.getFullYear()) {
                                monthCredits += element.amount_total;
                            }
                            if (date.getMonth() === today.getMonth() - 1 &&
                                date.getFullYear() === today.getFullYear()) {
                                lastMonthCredits += element.amount_total;
                            }
                            total += element.amount_total;
                        });

                        // format credits to string, dollars, 2 decimals
                        total = (total / 100).toFixed(2);
                        todayCredits = (todayCredits / 100).toFixed(2);
                        monthCredits = (monthCredits / 100).toFixed(2);
                        lastMonthCredits = (lastMonthCredits / 100).toFixed(2);

                        setCreditsTotal(total);
                        setCreditsToday(todayCredits);
                        setCreditsMonth(monthCredits);
                        setCreditsLastMonth(lastMonthCredits);

                        setCreditBalancesByUserId(balances);
                        setHistory(history);
                        setLoading(false);

                        let creditsChart = [];

                        history.forEach(item => {
                            const timestamp = item.timestamp;
                            const dateObj = new Date(timestamp);

                            // Get the month and year
                            const month = dateObj.getMonth(); // 0-11
                            const year = dateObj.getFullYear();

                            // Create a unique key for the month, e.g., '2023-10'
                            const monthKey = `${year}-${(month + 1).toString().padStart(2, '0')}`;

                            // Optionally, format the month to a readable string, e.g., 'October 2023'
                            const monthName = dateObj.toLocaleString('default', { month: 'long' });
                            const formattedMonth = `${monthName} ${year}`;

                            // Check if a credit entry for this month already exists
                            const existingEntry = creditsChart.find(entry => entry.monthKey === monthKey);

                            if (existingEntry) {
                                existingEntry.totalCredits += item.amount_total / 100;
                                existingEntry.totalPages += item.pages ? parseFloat(item.pages) : 0;
                            } else {
                                // Create a new entry for this month
                                const newEntry = {
                                    date: new Date(year, month, 1), // First day of the month
                                    monthKey: monthKey,             // e.g., '2023-10'
                                    formattedMonth: formattedMonth, // e.g., 'October 2023'
                                    totalCredits: item.amount_total / 100,
                                    totalPages: item.pages ? parseFloat(item.pages) : 0,
                                };

                                creditsChart.push(newEntry);
                            }
                        });

                        // i want the total credits to be a string and not a number, format with 2 decimals
                        creditsChart.forEach(entry => {
                            entry.totalCredits = entry.totalCredits.toFixed(2);
                            // entry.totalPages = entry.totalPages.toFixed(2);
                        });

                        // sort the credits chart by date in ascending order
                        creditsChart.sort((a, b) => a.date - b.date);

                        setCreditsChart(creditsChart);
                    } else {
                        setCreditBalancesByUserId({});
                        setLoading(false);
                    }
                }).catch((error) => {
                    setError(error);
                    console.error('Error fetching user billing data', error);
                });

            } catch (error) {
                setError(error);
                console.error('Error fetching user billing data', error);
            }
        };

        fetchCredits();
    }, []);

    const [searchTerm, setSearchTerm] = useState('');

    const filteredHistory = history.filter((element) => {
        const email = usersInfo[element.userId]?.email || element.userId;
        return (
            email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            element.userId.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });

    const [selectedUserId, setSelectedUserId] = useState('');
    const [open, setOpen] = useState(false);
    const [creditsView, setCreditsView] = useState('balances');

    const handleButtonClick = (userId) => {
        console.log('Button clicked for user:', userId);
        setSelectedUserId(userId);
        setOpen(true);
    }

    if (error) return <p>Error: {error.message}</p>;

    return (
        <div className="mt-4 flow-root">
            <ModalCustom open={open} setOpen={setOpen} >
                <ShowUserDetails userId={selectedUserId} closeModal={() => {
                    setOpen(false);
                    setSelectedUserId('');
                }} />
            </ModalCustom>

            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <DataDisplayCredits
                        today={creditsToday}
                        total={creditsTotal}
                        month={creditsMonth}
                        lastMonth={credistLastMonth}
                        totalClients={totalUsers}
                        totalTransactions={totalTransactions}
                        totalPages={totalPages + totalPagesBefore + totalPagesPartners + totalPagesJustin}
                        pricePerPage={((totalPagesPrice + totalPagesBeforePrice + totalPagesPartnersPrice + totalPagesJustinPrice) / (totalPages + totalPagesBefore + totalPagesPartners + totalPagesJustin)).toFixed(2)}
                    />

                    <div className="mt-5 flex rounded-lg border border-gray-200 bg-gray-100 p-1">
                        <button
                            type="button"
                            onClick={() => setCreditsView('balances')}
                            className={`flex-1 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors ${
                                creditsView === 'balances'
                                    ? 'bg-white text-gray-900 shadow-sm'
                                    : 'text-gray-600 hover:text-gray-900'
                            }`}
                        >
                            User credit balances
                        </button>
                        <button
                            type="button"
                            onClick={() => setCreditsView('activity')}
                            className={`flex-1 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors ${
                                creditsView === 'activity'
                                    ? 'bg-white text-gray-900 shadow-sm'
                                    : 'text-gray-600 hover:text-gray-900'
                            }`}
                        >
                            Credits chart &amp; transactions
                        </button>
                    </div>

                    {creditsView === 'balances' ? (
                        <div className="mt-5">
                            <UserCreditsBalancesAdmin
                                usersInfo={usersInfo}
                                creditBalancesByUserId={creditBalancesByUserId}
                            />
                        </div>
                    ) : (
                        <>
                    {/* <div>
              Total pages: {totalPages} Total price: {totalPagesPrice} Price per page: {(totalPagesPrice / totalPages).toFixed(2)}
              <br />
              Total pages justin: {totalPagesJustin} Total price justin: {totalPagesJustinPrice} Price per page justin: {(totalPagesJustinPrice / totalPagesJustin).toFixed(2)}
              <br />
              Total pages (+ justin): {totalPages + totalPagesJustin} Total price (+ justin): {totalPagesPrice + totalPagesJustinPrice}
              <br />
              Total pages before: {totalPagesBefore} Total price before: {totalPagesBeforePrice} Price per page before: {(totalPagesBeforePrice / totalPagesBefore).toFixed(2)}
              <br />
              Total pages partners: {totalPagesPartners} Total price partners: {totalPagesPartnersPrice} Price per page partners: {(totalPagesPartnersPrice / totalPagesPartners).toFixed(2)}
            </div> */}

                    <div className="mt-5 overflow-hidden rounded-lg bg-white px-4 py-5 sm:p-6 border">
                        <dt className="truncate text-sm font-medium text-gray-500">Credits</dt>
                        <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
                            <CreditsChart chartData={creditsChart} />
                        </dd>
                    </div>

                    <div className="mt-5 flex items-center px-4 py-3 bg-gray-50 sm:px-4">
                        <input
                            type="text"
                            placeholder="Search by email or user ID"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full px-4 py-2 mr-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                        <button
                            onClick={() => switchLastExtraction()}
                            className="inline-flex items-center gap-x-1 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 whitespace-nowrap"
                        >
                            Get last extractions
                        </button>
                    </div>

                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-300">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                        Email
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Value
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Pages
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Type
                                    </th>
                                    {lastExtractionEnabled && (
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            Last Extraction
                                        </th>
                                    )}
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Date
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                                {filteredHistory.map((element, index) => (
                                    <tr key={index}>
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                            <div className="flex items-center">
                                                <span>{usersInfo[element.userId] ? usersInfo[element.userId].email : element.userId}</span>
                                                <button
                                                    className="ml-2 text-indigo-600 hover:text-indigo-800"
                                                    onClick={() => {
                                                        handleButtonClick(element.userId);
                                                    }}
                                                    title="Show"
                                                >
                                                    Show
                                                </button>
                                            </div>
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {element.amount_total > 0 && element.credits > 0 && element.amount_total !== element.credits && (
                                                <span className="mr-1 text-xs"><del>${(element.credits / 100).toFixed(2)}</del></span>
                                            )}
                                            ${(element.amount_total / 100).toFixed(2)}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {element.pages ? element.pages : (element.type === 'pay-as-you-go' ? (((element.amount_total > 0 && element.credits > 0 && element.amount_total !== element.credit) ? element.credits : element.amount_total) / 100 * 10) : '-')}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {element.type ? element.type : '-'}
                                        </td>
                                        {lastExtractionEnabled && (
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                {lastExtractionLoading ? 'Loading...' : getLastExtraction(element.userId)}
                                            </td>
                                        )}
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {formatDate4(element.timestamp)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

// make functioon that formats 2025-05-26T12:12:01.290Z to readable date like 26 May 2025 14:12
const formatDate4 = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

const customTooltipCredits = ({ payload, active, label }) => {
    if (!active || !payload) return null;
    return (
        <div className="w-56 rounded-tremor-default text-tremor-default bg-tremor-background p-2 shadow-tremor-dropdown border border-tremor-border">
            <p className="font-medium text-tremor-content-emphasis mb-1">{label}</p>
            <div className="flex flex-row">
                {payload.map((category, idx) => (
                    <div key={idx} className="flex flex-1 space-x-2.5 mt-1">
                        <div className={`w-1 flex flex-col bg-${category.color}-500 rounded`} />
                        <div className="space-y-1">
                            <p className="text-tremor-content">{category.dataKey}</p>
                            <p className="font-medium text-tremor-content-emphasis">{category.value}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const valueFormatter = function (number) {
    return number.toString();
};

const CreditsChart = ({ chartData }) => {
    let maxValue = 13000;

    return (
        <AreaChart
            className="h-60 mt-4"
            data={chartData}
            index="formattedMonth"
            categories={["totalCredits"]}
            colors={["indigo", "cyan", "red"]}
            showAnimation={true}
            showLegend={true}
            allowDecimals={false}
            valueFormatter={valueFormatter}
            customTooltip={customTooltipCredits}
            yAxisWidth={68}
            showYAxis={true}
            showXAxis={true}
            maxValue={maxValue}
            style={{ width: '100%', height: '350px' }}
        />
    );
}

function DataDisplayCredits({ today, month, lastMonth, total, totalPages, totalClients, totalTransactions, pricePerPage }) {
    const stats = [
        { name: 'Credits Today', stat: today, icon: true },
        { name: 'Credits Current Month', stat: month, icon: true },
        { name: 'Credits Last Month', stat: lastMonth, icon: true },
        { name: 'Total Credits', stat: total, icon: true },
        { name: 'Total Pages', stat: totalPages, icon: false },
        { name: 'Price per page', stat: pricePerPage, icon: true },
        { name: 'Total Clients', stat: totalClients, icon: false },
        { name: 'Total Transactions', stat: totalTransactions, icon: false },
    ];

    // format each stat, transform to double, convert to string, add thousands separator
    stats.forEach((item) => {
        if (item.icon) {
            item.stat = parseFloat(item.stat).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            item.stat = parseFloat(item.stat).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    });

    return (
        <div>
            <dl className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-4">
                {stats.map((item) => (
                    <div key={item.name} className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                        <dt className="truncate text-sm font-medium text-gray-500">{item.name}</dt>
                        <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{item.icon ? '$' : ''}{item.stat}</dd>
                    </div>
                ))}
            </dl>
        </div>
    )
}